module.exports = __webpack_public_path__ + "static/media/logo-manorBrain.3025ad20.png";